export default __webpack_public_path__ + "static/media/sustentabilidade1.35b01e97.jpg";